import { InputLabel, InputLabelProps, SxProps } from '@mui/material';
import TextField from '@mui/material/TextField';

export interface IMuiTextField {
    id: string;
    label?: string | boolean;
    size?: 'small' | 'medium' | undefined;
    onChange: (event: any) => void;
    value: string | number;
    fullWidth?: boolean;
    type?: string;
    placeholder?: string;
    inputProps?: any;
    InputProps?: any;
    InputLabelProps?: Partial<InputLabelProps>;
    disabled?: boolean;
    sx?: SxProps;
    topLabel?: boolean;
}

export const MuiTextField = ({
    id,
    label = false,
    size,
    type,
    placeholder,
    fullWidth = false,
    onChange,
    value,
    inputProps,
    InputProps,
    InputLabelProps,
    disabled,
    sx,
    topLabel = false,
}: IMuiTextField) => {
    return (
        <>
            {topLabel && label && <InputLabel htmlFor={id}>{label}</InputLabel>}
            <TextField
                sx={sx}
                id={id}
                label={topLabel ? '' : label}
                variant="outlined"
                type={type}
                size={size}
                fullWidth={fullWidth}
                placeholder={placeholder}
                autoComplete="off"
                onChange={onChange}
                value={value}
                inputProps={inputProps}
                InputProps={InputProps}
                InputLabelProps={InputLabelProps}
                disabled={disabled}
            />
        </>
    );
};
